<div class="footer-banner">
    <img class="img-responsive" src="/assets/images/banners/footer-banner.png" alt="Editorial Astrea: Tradición editorial desde 1942">
</div>

<footer class="astrea-footer py-4 px-2">

    <div class="container">

        <div class="d-flex j-c-around flex-wrap">
            <div class="astrea-logo">
                <img class="img-responsive" src="/assets/images/astrea-brand/logo_web_white.png" alt="{{ 'logo' | translate }}">
            </div>
            <div class="mb-3">
                <h4>{{ 'footer.about' | translate }}</h4>
                <ul>
                    <li><a routerLink="/recent" title="{{ 'navigation.recent' | translate }}">{{ 'navigation.recent' | translate }}</a></li>
                    <li><a routerLink="/authors" title="{{ 'navigation.authors' | translate }}">{{ 'navigation.authors' | translate }}</a></li>
                    <li><a routerLink="/doctrine" title="{{ 'navigation.doctrine' | translate }}">{{ 'navigation.doctrine' | translate }}</a></li>
                    <li><a routerLink="/articles" title="{{ 'navigation.magazines' | translate }}">{{ 'navigation.magazines' | translate }}</a></li>
                    <li><a routerLink="/editorials" title="{{ 'navigation.editorials' | translate }}">{{ 'navigation.editorials' | translate }}</a></li>
                    <li><a routerLink="/collections" title="{{ 'navigation.collections' | translate }}">{{ 'navigation.collections' | translate }}</a></li>
                    <li><a routerLink="/materias" title="{{ 'navigation.matter' | translate }}">{{ 'navigation.matter' | translate }}</a></li>
                </ul>
            </div>

            <div class="mb-3">
                <h4>{{ 'footer.help' | translate }}</h4>
                <ul>
                    <li><a routerLink="/about/history" title="{{ 'navigation.editorial.editorial' | translate }}">{{ 'navigation.editorial.editorial' | translate }}</a></li>
                    <li><a routerLink="/astreavirtual" title="Astrea Virtual">Astrea Virtual</a></li>
                    <li><a routerLink="/contact" title="{{ 'navigation.contact' | translate }}">{{ 'navigation.contact' | translate }}</a></li>
                </ul>
            </div>

            <div class="footer-social d-flex flex-column j-c-start a-i-start">
                <p><strong>{{ 'footer.social' | translate }}</strong></p>
                <div class="mt-3">
                    <a href="https://www.facebook.com/EditorialAstrea" target="_blank">
                        <svg width="22" height="30" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23 1H17C14.3478 1 11.8043 2.05357 9.92893 3.92893C8.05357 5.8043 7 8.34784 7 11V17H1V25H7V41H15V25H21L23 17H15V11C15 10.4696 15.2107 9.96086 15.5858 9.58579C15.9609 9.21071 16.4696 9 17 9H23V1Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                    <a href="https://www.instagram.com/EditorialAstrea" target="_blank">
                        <svg width="30" height="30" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1">
                            <path d="M32 10H32.02M11 1H31C36.5228 1 41 5.47715 41 11V31C41 36.5228 36.5228 41 31 41H11C5.47715 41 1 36.5228 1 31V11C1 5.47715 5.47715 1 11 1ZM29 19.74C29.2468 21.4045 28.9625 23.1044 28.1875 24.598C27.4125 26.0916 26.1863 27.3028 24.6833 28.0593C23.1802 28.8159 21.4769 29.0792 19.8156 28.8119C18.1543 28.5445 16.6195 27.7602 15.4297 26.5703C14.2398 25.3805 13.4555 23.8457 13.1881 22.1844C12.9208 20.5231 13.1841 18.8198 13.9407 17.3167C14.6972 15.8137 15.9084 14.5875 17.402 13.8125C18.8956 13.0375 20.5955 12.7532 22.26 13C23.9578 13.2518 25.5297 14.0429 26.7434 15.2566C27.9571 16.4703 28.7482 18.0422 29 19.74Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                    <a href="https://www.linkedin.com/company/editorial-astrea" target="_blank">
                        <svg width="30" height="30" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M29 13C32.1826 13 35.2348 14.2643 37.4853 16.5147C39.7357 18.7652 41 21.8174 41 25V39H33V25C33 23.9391 32.5786 22.9217 31.8284 22.1716C31.0783 21.4214 30.0609 21 29 21C27.9391 21 26.9217 21.4214 26.1716 22.1716C25.4214 22.9217 25 23.9391 25 25V39H17V25C17 21.8174 18.2643 18.7652 20.5147 16.5147C22.7652 14.2643 25.8174 13 29 13Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 15H1V39H9V15Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <div class="footer-slogan d-flex j-c-around a-i-center mt-4 w-100">
            <p class="t-center">Copyright © {{ currentYear }} Editorial Astrea</p>
            <div class="d-flex j-c-between a-i-center">
                <a routerLink="/terms" title="{{ 'terms.title' | translate }}">{{ 'terms.title' | translate }}</a>
                <a routerLink="/policy" title="{{ 'policy.title' | translate }}">{{ 'policy.title' | translate }}</a>
            </div>
        </div>

    </div>

</footer>
